<template>
  <!-- Wraps unconditionally: the non-stacked variant renders into a v-toolbar
       slot, whose content row is nowrap at a fixed height, so without this the
       tabs, search and action buttons overflow the card on narrow viewports. -->
  <div class="d-flex align-center flex-wrap">
    <!-- Own row: the tabs sit centered rather than hugging the title. -->
    <v-spacer v-if="stacked" />
    <v-spacer v-if="stacked" />
    <v-spacer v-if="stacked" />

    <v-btn
      v-for="({ name }, index) in tabs"
      :key="name"
      class="action-btn"
      :color="currentTab === index ? 'success' : 'grey lighten-1'"
      @click="$emit('tab-change', index)"
    >
      {{ name }}
    </v-btn>

    <v-spacer />

    <div
      class="flex-grow-1"
      :class="actionsWrapped ? 'mr-0' : 'mr-4'"
      style="min-width: 180px; max-width: 320px"
    >
      <SearchField
        :value="search"
        :loading="searchLoading"
        @input="$emit('update:search', $event)"
      />
    </div>

    <!-- The button group grows to fill the remaining space on its row and
         right-justifies the buttons, so they hug the right edge whether they
         share the row with the search or wrap onto their own line. Below ~1600px
         the buttons wrap, so a top margin is applied there (via the reactive
         breakpoint width) and dropped once they lay out inline. -->
    <PossiblePMS v-slot="{ disabled }" :content-class="actionsContentClass">
      <v-btn
        class="action-btn"
        color="success"
        :to="{ name: 'AddSmartUnit' }"
        :disabled="disabled"
      >
        Create New Smart Unit
      </v-btn>
      <v-btn class="action-btn ml-2" color="primary" @click="$emit('scan')">
        <v-icon left>fas fa-qrcode</v-icon>
        Scan Device
      </v-btn>
    </PossiblePMS>
  </div>
</template>

<script>
import SearchField from "@atoms/SearchField.vue";
import PossiblePMS from "@components/common/PossiblePMS.vue";

export default {
  name: "InventoryHeaderActions",
  components: { SearchField, PossiblePMS },
  props: {
    // [{ name }, ...] — one entry per inventory tab, in display order.
    tabs: {
      type: Array,
      required: true,
    },
    currentTab: {
      type: Number,
      default: 0,
    },
    search: {
      type: String,
      default: "",
    },
    searchLoading: {
      type: Boolean,
      default: false,
    },
    // Rendered as its own row under the page header instead of inside it.
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["tab-change", "update:search", "scan"],
  computed: {
    // Below ~1600px the action buttons wrap onto their own row. Tracked via
    // Vuetify's reactive breakpoint width so no custom CSS media query is needed
    // for this non-standard width.
    actionsWrapped() {
      return this.$vuetify.breakpoint.width < 1600;
    },
    // Give the wrapped button row a top margin so it clears the tabs/search, and
    // drop it once the buttons lay out inline.
    actionsContentClass() {
      const base = "d-flex justify-end flex-grow-1";
      return this.actionsWrapped ? `${base} mt-2` : base;
    },
  },
};
</script>
